import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'index',
    component: () => import('@/pages/index/IndexPage.vue'),
    meta: { title: '首页', requiresAuth: false },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/login/LoginPage.vue'),
    meta: { title: '登录', requiresAuth: false },
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/pages/dashboard/DashboardPage.vue'),
    meta: { title: '控制台', requiresAuth: true },
  },
  {
    path: '/visa',
    name: 'visa',
    component: () => import('@/pages/visa/VisaPage.vue'),
    meta: { title: '签证管理', requiresAuth: true },
  },
  {
    path: '/cost',
    name: 'cost',
    component: () => import('@/pages/cost/CostPage.vue'),
    meta: { title: '生活成本', requiresAuth: true },
  },
  {
    path: '/timezone',
    name: 'timezone',
    component: () => import('@/pages/timezone/TimezonePage.vue'),
    meta: { title: '时区管理', requiresAuth: true },
  },
  {
    path: '/tax',
    name: 'tax',
    component: () => import('@/pages/tax/TaxPage.vue'),
    meta: { title: '税务助手', requiresAuth: true },
  },
  {
    path: '/guide',
    name: 'guide',
    component: () => import('@/pages/guide/GuidePage.vue'),
    meta: { title: '旅居指南', requiresAuth: true },
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('@/pages/settings/SettingsPage.vue'),
    meta: { title: '设置', requiresAuth: true },
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/pages/about/AboutPage.vue'),
    meta: { title: '关于', requiresAuth: false },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/pages/notfound/NotFoundPage.vue'),
    meta: { title: '404', requiresAuth: false },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(_to, _from, savedPosition) {
    return savedPosition || { top: 0 }
  },
})

router.beforeEach((to, _from, next) => {
  const title = to.meta.title as string | undefined
  if (title) {
    document.title = `${title} - 游民助手 NomadMate`
  }

  if (to.meta.requiresAuth) {
    const token = localStorage.getItem('nm_token')
    if (!token) {
      next({ name: 'login', query: { redirect: to.fullPath } })
      return
    }
  }

  next()
})

export default router
